import { render } from "./reservationsDatatable.vue?vue&type=template&id=be58953c&scoped=true"
import script from "./reservationsDatatable.vue?vue&type=script&lang=js"
export * from "./reservationsDatatable.vue?vue&type=script&lang=js"

import "./reservationsDatatable.vue?vue&type=style&index=0&id=be58953c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be58953c"]])

export default __exports__